import { render, staticRenderFns } from "./TabelaLimiteProtesto.vue?vue&type=template&id=bb505454&scoped=true&"
import script from "./TabelaLimiteProtesto.vue?vue&type=script&lang=js&"
export * from "./TabelaLimiteProtesto.vue?vue&type=script&lang=js&"
import style0 from "./TabelaLimiteProtesto.vue?vue&type=style&index=0&id=bb505454&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb505454",
  null
  
)

export default component.exports